import actionTypes from '../constants/action-types';

const cleanUrlsEnabled = (state = false, action) => {
  switch (action.type) {
    case actionTypes.RELOAD_SITE_META:
    case actionTypes.CONNECT_SITE: {
      const { onlinestore } = action.payload.site.meta;
      return Boolean(onlinestore && onlinestore.cleanUrlsEnabled);
    }
    case actionTypes.SET_CLEAN_URL_ENABLED:
      return action.payload.cleanUrlsEnabled;
    default:
      return state;
  }
};

export default cleanUrlsEnabled;
